import { useState, useEffect } from "react";
import {
  RecaptchaVerifier,
  PhoneAuthProvider,
  multiFactor,
  PhoneMultiFactorGenerator,
  EmailAuthProvider,
  reauthenticateWithCredential
} from "firebase/auth";
import { auth } from "../firebase_config";

function AddTwoFactor() {
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");
  const [verificationId, setVerificationId] = useState(null);

  useEffect(() => {
    try {
      if (!window.recaptchaVerifier) {
        window.recaptchaVerifier = new RecaptchaVerifier(
          "recaptcha-container",
          {
            size: "invisible",
            callback: (response) => {
              console.log("✅ reCAPTCHA löst:", response);
            },
            "expired-callback": () => {
              console.log("🔁 reCAPTCHA gick ut, rendera om om det behövs.");
            },
          },
          auth
        );

        window.recaptchaVerifier.render().then((widgetId) => {
          console.log("✅ reCAPTCHA widget ID:", widgetId);
        });
      }
    } catch (err) {
      console.error("❌ Fel vid reCAPTCHA-initiering:", err);
    }
  }, []);

  const sendSms = async () => {
    try {
      const password = prompt("🔐 Ange ditt lösenord för att verifiera dig:");
      const cred = EmailAuthProvider.credential(auth.currentUser.email, password);
      await reauthenticateWithCredential(auth.currentUser, cred);
      console.log("✅ Reautenticering lyckades");

      const session = await multiFactor(auth.currentUser).getSession();
      console.log("✅ MFA-session skapad");

      const phoneProvider = new PhoneAuthProvider(auth);
      const id = await phoneProvider.verifyPhoneNumber(
        { phoneNumber: phone, session },
        window.recaptchaVerifier
      );

      console.log("📲 verificationId:", id);
      setVerificationId(id);
    } catch (err) {
      console.error("❌ Kunde inte skicka SMS:", err);
    }
  };

  const verifyCode = async () => {
    try {
      const cred = PhoneAuthProvider.credential(verificationId, code);
      const assertion = PhoneMultiFactorGenerator.assertion(cred);

      await multiFactor(auth.currentUser).enroll(assertion, "SMS 2FA");
      alert("✅ Tvåfaktoraktivering lyckades!");
    } catch (err) {
      console.error("❌ Fel vid verifiering:", err);
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>📱 Aktivera tvåfaktorautentisering</h2>

      <input
        type="tel"
        placeholder="t.ex. +46700000000"
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
      />
      <button onClick={sendSms}>Skicka SMS</button>

      {verificationId && (
        <>
          <input
            type="text"
            placeholder="Verifieringskod"
            value={code}
            onChange={(e) => setCode(e.target.value)}
          />
          <button onClick={verifyCode}>Verifiera kod</button>
        </>
      )}

      <div id="recaptcha-container" style={{ marginTop: 20 }}></div>
    </div>
  );
}

export default AddTwoFactor;